var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotographyCategoryLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M29 32C29 30.8954 29.8954 30 31 30H37C38.1046 30 39 30.8954 39 32V38H29V32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M65 32C65 30.8954 65.8954 30 67 30H70C71.1046 30 72 30.8954 72 32V38H65V32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M41.1961 28.5474C41.4066 27.6413 42.214 27 43.1442 27H57.8558C58.786 27 59.5934 27.6413 59.8039 28.5474L62 38H39L41.1961 28.5474Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M25 37C25 35.3431 26.3431 34 28 34H73C74.6569 34 76 35.3431 76 37V70C76 71.6569 74.6569 73 73 73H28C26.3431 73 25 71.6569 25 70V37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M63 54C63 60.6274 57.6274 66 51 66C44.3726 66 39 60.6274 39 54C39 47.3726 44.3726 42 51 42C57.6274 42 63 47.3726 63 54Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M56 54C56 56.7614 53.7614 59 51 59C48.2386 59 46 56.7614 46 54C46 51.2386 48.2386 49 51 49C53.7614 49 56 51.2386 56 54Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M65 41.5C65 39.567 66.567 38 68.5 38C70.433 38 72 39.567 72 41.5C72 43.433 70.433 45 68.5 45C66.567 45 65 43.433 65 41.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotographyCategoryLight);
export default __webpack_public_path__ + "static/media/photography-category-light.b4073494e0f8cb6f1fd276210b3afdb6.svg";
export { ForwardRef as ReactComponent };